import type * as React from 'react';
import * as styles from './SpecificationItem.css';

interface ISpecificationItem {
  title: string;
  value: string;
}
export const SpecificationItem = (props: ISpecificationItem): React.JSX.Element => {
  return (
    <div className={styles['container']}>
      <div className={styles['title']}>{props.title}</div>

      <div className={styles['value']}>{props.value}</div>
    </div>
  );
};
